export * from './filtro-instituicao';
export * from './instituicao.model';
export * from './instituicao.service';



// WEBPACK FOOTER //
// ./src/app/restrito/instituicao/shared/index.ts